import React from "react";
import { motion } from "framer-motion";
import AnimatedSection from "../../WebDevelopmentPage/components/AnimatedSection";
import { gdPanels } from "../gdModulesData";
import GdImagePlaceholder from "./GdImagePlaceholder";

const FeatureGrid: React.FC<{ left: string[]; right: string[] }> = ({ left, right }) => (
  <div className="gd-panel__features">
    <ul className="gd-panel__list">
      {left.map((item) => (
        <li key={item}>
          <span className="gd-panel__dot" aria-hidden="true" />
          {item}
        </li>
      ))}
    </ul>
    <ul className="gd-panel__list">
      {right.map((item) => (
        <li key={item}>
          <span className="gd-panel__dot" aria-hidden="true" />
          {item}
        </li>
      ))}
    </ul>
  </div>
);

const GdPanelsSection: React.FC = () => {
  return (
    <section className="gd-panels" aria-labelledby="gd-panels-title">
      <div className="container">
        <AnimatedSection className="wdev-section-head wdev-section-head--center">
          <h2 id="gd-panels-title" className="wdev-section-head__title">
            Admin &amp; Vendor Panels
          </h2>
          <p className="gd-panels__lead">
            Fully integrated panels to manage your grocery business and empower store vendors.
          </p>
        </AnimatedSection>

        <div className="gd-panels__stack">
          {gdPanels.map((panel, index) => (
            <motion.article
              key={panel.id}
              className={`gd-panel ${panel.imagePosition === "right" ? "gd-panel--reverse" : ""}`}
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.55, delay: index * 0.1 }}
            >
              <div className="gd-panel__visual">
                <GdImagePlaceholder
                  variant={panel.placeholderVariant}
                  label={panel.placeholderLabel}
                  hint={panel.placeholderHint}
                  className="gd-panel__placeholder"
                />
              </div>

              <div className="gd-panel__content">
                <h3 className="gd-panel__title">{panel.title}</h3>
                <p className="gd-panel__desc">{panel.description}</p>
                <FeatureGrid left={panel.featuresLeft} right={panel.featuresRight} />
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default GdPanelsSection;
